import { render, staticRenderFns } from "./CubeGrid.vue?vue&type=template&id=62241b81&scoped=true"
import script from "./CubeGrid.vue?vue&type=script&lang=js"
export * from "./CubeGrid.vue?vue&type=script&lang=js"
import style0 from "./CubeGrid.vue?vue&type=style&index=0&id=62241b81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62241b81",
  null
  
)

export default component.exports